import { Backdrop, CircularProgress } from '@mui/material'
import { LoadingContext } from 'contexts/LoadingContextProvider'
import { useContext } from 'react'

const CustomLoadingProcess = () => {
  const { loading } = useContext(LoadingContext)
  return (
    <Backdrop
      sx={theme => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open={loading}
    >
      <CircularProgress
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      />
    </Backdrop>
  )
}

export default CustomLoadingProcess
